<template>
    <div class="w-100 px-2">
        <template v-if="isOnContract">
            <span v-if="forceToNumber(firstOnContract.line.price) === forceToNumber(line.price)"
                  :key="`${lineIdx}-item-price-equal`"
                  class="text-success d-inline-block"
                  v-tooltip="`Contract item price ${firstOnContract.line.price} equal to line item price ${line.price}`">
                On Contract
            </span>
            <span v-else-if="forceToNumber(firstOnContract.line.price) > forceToNumber(line.price)"
                  :key="`${lineIdx}-item-price-greater`"
                  class="text-success d-inline-block"
                  v-tooltip="`Contract item price ${firstOnContract.line.price} greater than line item price ${line.price}`">
                Under Contract
            </span>
            <span v-else :key="`${lineIdx}-item-price-less`"
                  class="text-danger d-inline-block"
                  v-tooltip="`Contract item price ${firstOnContract.line.price} less than line item price ${line.price}`">
                Over Contract
            </span>

            <a @click.prevent="viewContract(firstOnContract)" href="#" class="pl-1">
                <span class="text-dark">
                    <i class="fal fa-external-link-alt"></i>
                </span>
            </a>
        </template>
        <span v-else-if="isOffContract" class="text-danger">
            <span v-tooltip="'The item is off contract for this supplier'">
                Off Contract
            </span>
            <a @click.prevent="viewContract(firstOffContract)" href="#" class="pl-1">
                <span class="text-dark">
                    <i class="fal fa-external-link-alt"></i>
                </span>
            </a>
        </span>
        <span v-else class="text-muted">
            No Contract
        </span>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import {first, get} from 'lodash'
import {forceToNumber} from '@/utils'

export default Vue.extend({
    name: 'AgGridCellRendererContractCheck',
    computed: {
        ...mapGetters([
            'activeTeamId'
        ]),

        ...mapGetters('doc_viewer', [
            'lines',
            'checkContractResponse'
        ]),

        lineIdx() {
            return this.params.data ? this.params.data.lineIdx : -1
        },

        line() {
            return this.lines[this.lineIdx] || {}
        },

        itemId() {
            return get(this.line, 'item_uuid')
        },

        checkContractResponseItem() {
            return this.checkContractResponse.find((r) => get(r.item, 'uuid') === this.itemId)
        },

        offContracts() {
            return get(this.checkContractResponseItem, 'off_contracts') || []
        },

        onContracts() {
            return get(this.checkContractResponseItem, 'on_contracts') || []
        },

        firstOnContract() {
            return first(this.onContracts)
        },

        firstOffContract() {
            return first(this.offContracts)
        },

        isOffContract() {
            return !!this.firstOffContract
        },

        isOnContract() {
            return !!this.firstOnContract
        }
    },
    methods: {
        forceToNumber,

        viewContract(contract) {
            if (!contract || !contract.uuid) {
                return
            }
            const routeData = this.$router.resolve({
                name: `contracts.view`,
                params: {
                    team: this.activeTeamId,
                    docUuid: contract.uuid
                }
            })
            window.open(routeData.href, '_blank')
        }
    }
})
</script>

<style lang="scss" scoped>
</style>
